import { useState, useEffect } from 'react';
import './Approach.scss';

const versions = [
  [
    {
      num: '01',
      title: 'OBSERVER',
      desc: "Comprendre les personnes, les usages et l'environnement du projet.",
    },
    {
      num: '02',
      title: 'SIMPLIFIER',
      desc: 'Transformer la complexité en solutions claires, intuitives et efficaces.',
    },
    {
      num: '03',
      title: 'CRÉER',
      desc: 'Donner forme à des idées qui allient sens, esthétique et fonctionnalité.',
    },
    {
      num: '04',
      title: 'TRANSMETTRE',
      desc: "Construire des marques, des produits et des expériences capables d'évoluer dans le temps.",
    },
  ],
  [
    {
      num: '01',
      title: 'STRATÉGIE',
      desc: 'Comprendre le contexte, les enjeux et les opportunités avant toute décision créative.',
    },
    {
      num: '02',
      title: 'EXPÉRIENCE',
      desc: "Construire des parcours fluides, intuitifs et centrés sur l'utilisateur.",
    },
    {
      num: '03',
      title: 'IDENTITÉ',
      desc: 'Créer des univers visuels qui donnent du caractère, du sens et de la cohérence aux projets.',
    },
    {
      num: '04',
      title: 'IMPACT',
      desc: 'Transformer les idées en expériences mémorables et en résultats concrets.',
    },
  ],
];

const Approach = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setActiveIndex(i => (i + 1) % versions.length);
        setVisible(true);
      }, 500);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const steps = versions[activeIndex];

  return (
    <section className="approach" id="approach">
      <div className="approach__header">
        <span className="approach__label">03</span>
        <h2 className="approach__title">MON APPROCHE</h2>
      </div>

      <div className={`approach__steps${visible ? '' : ' approach__steps--hidden'}`}>
        {steps.map(({ num, title, desc }) => (
          <div className="approach__step" key={num}>
            <span className="approach__num">{num}</span>
            <h3 className="approach__step-title">{title}</h3>
            <p className="approach__step-desc">{desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Approach;
